import { CurrencyPipe } from '@angular/common';
import type { OnChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import type { Addon, BillingPlan, PaymentInterval } from '@core/billing-types';
import { I18nService } from '@core/i18n-legacy';
import { DividerComponent } from '@core/user-interface-legacy';

import { getPaymentIntervalText } from '../../helpers/get-payment-interval-text';
import { getProductCost } from '../../helpers/get-product-cost';

@Component({
  selector: 'rt-subscription-cost',
  templateUrl: './subscription-cost.component.html',
  styleUrls: ['./subscription-cost.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DividerComponent, CurrencyPipe],
})
export class SubscriptionCostComponent implements OnChanges {
  private readonly i18n = inject(I18nService);

  @Input() public product: BillingPlan;
  @Input() public slots: number;
  @Input() public addons: Addon[];
  @Input() public interval: PaymentInterval;

  public totalCost: number;
  public intervalText: string;

  public ngOnChanges() {
    this.totalCost = getProductCost(this.product, this.slots, this.interval, this.addons);
    this.intervalText = getPaymentIntervalText(this.interval, this.i18n);
  }
}
